export default Object.freeze({
  Preelegibles: 0,
  Reclamaciones: 1,
});
